module.exports = __webpack_public_path__ + "static/media/18ECA10.5da23cae.jpg";